import { deleteEntityQuery, QueryKeys } from '@common/queries/common';
import { Entity } from '@common/types/Entity';
import { EntityEvents } from '@common/user-analytics';
import { EntityKind } from '@prophecy/graphql-types/enums';
import { toast } from '@prophecy/ui-v3/ui-compat';
import { useQueryClient } from '@tanstack/react-query';
import { useMixPanel } from 'frontend/core/src/context/mixpanel/context';
import { useGraphQlMutation } from 'frontend/core/src/data/util';

export function useDeleteTeam() {
  const queryClient = useQueryClient();
  const { track } = useMixPanel();
  const mutation = useGraphQlMutation(deleteEntityQuery);

  const deleteTeam = async (entityId: string) => {
    const variables = {
      uid: entityId,
      entityKind: Entity.Team as unknown as EntityKind
    };

    track(EntityEvents.common.metadata.entityDelete, { entityId, entity: Entity.Team });
    await mutation.mutateAsync(variables);
    toast.success({ content: `Deleted ${Entity.Team}` });

    // Will reset the data for specific entity
    queryClient.resetQueries([Entity.Team]);
    queryClient.invalidateQueries([QueryKeys.Git]);
    queryClient.invalidateQueries([QueryKeys.Project]);

    return true;
  };

  return { deleteTeam };
}
